module.exports = __webpack_public_path__ + "fonts/memnYaGs126MiZpBA-UFUKXGUdhoIqOjjg.9e7a52f0.woff2";